import React from 'react';
import { Button, Form, FormControl, InputGroup, Modal } from 'react-bootstrap';
import LoadingBox from './LoadingBox';

export default function SiparisBolModal(props) {
  const {
    showDivideItem,
    setShowDivideItem,
    setDivideFirstPart,
    setDivideSecondPart,
    divideFirstPart,
    divideSecondPart,
    selectedProduct,
    divideCartItemHandler,
    siparisDivideLoading,
  } = props;
  return (
    <Modal
      backdrop="static"
      centered
      size="sm"
      show={showDivideItem}
      onHide={() => setShowDivideItem(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Siparişi Böl</Modal.Title>
        <div className="ms-2">
          {siparisDivideLoading && <LoadingBox></LoadingBox>}
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Birinci Sipariş</Form.Label>
          <InputGroup style={{ width: '70%' }}>
            <Button
              onClick={() => {
                setDivideFirstPart(divideFirstPart - 1);
                setDivideSecondPart(divideSecondPart + 1);
              }}
              variant="light"
              className="border-primary text-primary"
              disabled={divideFirstPart === 1}
            >
              <span className="text-bold">-{1}</span>
            </Button>{' '}
            <FormControl
              type="text"
              disabled={true}
              value={divideFirstPart + ' Adet'}
            ></FormControl>
            <Button
              onClick={() => {
                setDivideFirstPart(divideFirstPart + 1);
                setDivideSecondPart(divideSecondPart - 1);
              }}
              variant="light"
              className="border-primary text-primary"
              disabled={divideSecondPart === 1}
            >
              <span className="text-bold">+{1}</span>
            </Button>
          </InputGroup>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>İkinci Sipariş</Form.Label>
          <InputGroup style={{ width: '70%' }}>
            <Button
              onClick={() => {
                setDivideSecondPart(divideSecondPart - 1);
                setDivideFirstPart(divideFirstPart + 1);
              }}
              variant="light"
              className="border-primary text-primary"
              disabled={divideSecondPart === 1}
            >
              <span className="text-bold">-{1}</span>
            </Button>{' '}
            <FormControl
              type="text"
              disabled={true}
              value={divideSecondPart + ' Adet'}
            ></FormControl>
            <Button
              onClick={() => {
                setDivideSecondPart(divideSecondPart + 1);
                setDivideFirstPart(divideFirstPart - 1);
              }}
              variant="light"
              className="border-primary text-primary"
              disabled={divideFirstPart === 1}
            >
              <span className="text-bold">+{1}</span>
            </Button>
          </InputGroup>
        </Form.Group>
        <small id="passwordHelpBlock" className="form-text text-muted">
          <span className="text-danger">
            {selectedProduct.feature ? selectedProduct.feature.name + ' ' : ''}
            {selectedProduct.name} {' siparişiniz '}
            {divideFirstPart} {' ve '}
            {divideSecondPart + ' adet '}
            olmak üzere iki ayrı siparişe bölünecektir
          </span>
        </small>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={siparisDivideLoading}
          variant="light"
          className="text-primary border-primary"
          onClick={async () => {
            divideCartItemHandler();
          }}
        >
          Siparişi Böl
        </Button>
        <Button
          variant="light"
          className="text-danger border-danger"
          onClick={() => setShowDivideItem(false)}
          disabled={siparisDivideLoading}
        >
          İptal
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
